import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
const bugsnagClient = Bugsnag.start({
  apiKey: 'fa5752843c8d16292989a264a83f7c7c',
  plugins: [new BugsnagPluginReact(React)],
});
export default bugsnagClient;